module.exports = __webpack_public_path__ + "img/full.2b4b3f71.png";